var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{staticClass:"manage-users-container",attrs:{"query":_vm.USERS_QUERY},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [_c('alert',{attrs:{"error":error}}),_c('user-list',{attrs:{"users":(data && data.users) || [],"loading":loading}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }